// extracted by mini-css-extract-plugin
export var accordion = "_ai-0";
export var chevron = "_ai-3";
export var closed = "_ai-2";
export var content = "_ai-4";
export var open = "_ai-1";
export var rotate = "_ai-5";